import { Box } from '@mui/material';

interface BranchLetterBallProps {
  letter: string | null;
  size?: number;
}

export const BranchLetterBall = ({ letter, size = 28 }: BranchLetterBallProps) => {
  if (!letter) {
    return null;
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.5,
        fontWeight: 600,
        flexShrink: 0,
      }}
      title={`Branch letter: ${letter}`}
    >
      {letter}
    </Box>
  );
};

